import * as React from 'react';

interface LoaderState {
  loading: boolean;
}

export class Loader extends React.Component<Record<string, unknown>, LoaderState> {
  constructor(props: Record<string, unknown>) {
    super(props);

    this.state = {
      loading: false,
    };
  }

  componentWillMount() {
    document.addEventListener('dp-loading', (event) => {
      // console.log('Loading');
      this.setState({
        loading: true,
      });
    });

    document.addEventListener('dp-loaded', (event) => {
      // console.log('loaded');
      this.setState({
        loading: false,
      });
    });
  }

  render() {
    return (
      <div>
        {this.state.loading &&
        <div className="wrapperLoader">
        <div className="text-center" style={{ marginTop: '100px' }}>
          <div>
              <span className="loader pl-0 loader-quart-8">
                <img src="/order/images/ic_compte.svg"/>
              </span>
            <div className="textLoader">Chargement ...</div>
          </div>
        </div>
        </div>
        }
      </div>
    );
  }
}
